



















import { defineComponent } from "@vue/composition-api";
import { SubscriptionLevel } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { $t } from "@/lib/i18nHelpers";
import { getCostByCurrency, getMainCurrencyCode } from "@/lib/moneyHelpers";
import CardCost from "@/components/CardCost";

export default defineComponent({
  name: "SubscriptionItem",
  components: { CardCost },
  props: {
    subscriptionLevel: { type: Object as () => SubscriptionLevel, required: true },
    activeSubscriptionLevel: { type: Boolean, default: false },
    processingLevelId: { type: String },
    hasSubscription: { type: Boolean, default: false },
    gradient: { type: Boolean, default: false },
    secondary: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isUnlockFeed: { type: Boolean, default: true },
  },
  computed: {
    mainCurrencyCode(): string {
      return getMainCurrencyCode();
    },
    cost(): number {
      return getCostByCurrency(this.subscriptionLevel.pricePackage)?.cost ?? 0;
    },
    buttonText(): string {
      if (this.isUnlockFeed) {
        return $t("Subscribe and unlock");
      } else if (this.hasSubscription) {
        return $t("Upgrade");
      }
      return $t("Subscribe");
    },
  },
  methods: {
    handleClick() {
      if (this.disabled) return;
      this.$emit("subscribe", this.subscriptionLevel);
    },
  },
});
